<template>
  <div :class="$style.container">
    <el-pagination
            background=""
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page.current"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="page.size"
            layout="sizes, prev, pager, next"
            v-if="page.total > page.size || page.size > 5" :class="$style.pagination"
            :total="page.total">
          </el-pagination>
  </div>
</template>
<script>
export default {
  props: {
    page: {
      type: Object,
      default: () => {
        return {
          current: 1,
          size: 10,
          total: 1
        }
      }
    }
  },
  methods: {
    // 改变每页的数量
    handleSizeChange (size) {
      this.$emit('changePage', '', size)
    },
    // 改变页码信息
    handleCurrentChange (page) {
      this.$emit('changePage', page, '')
    }
  }

}
</script>

<style lang="scss" module>
  .container {
    .pagination {
          margin-top: 15px;
          text-align: left;
          padding: 0;

        }
  }
</style>



// WEBPACK FOOTER //
// src/components/pagination.vue